var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import LoadingButton from '@mui/lab/LoadingButton';
import { Button as MuiButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { alpha, useTheme } from '@mui/material/styles';
import * as Preact from 'preact';
import { CheckCircleIcon } from './icons';
import { useTranslations } from './utils/TranslationsWrapper';
var selectionButtonSx = {
    width: '100%',
    borderRadius: '5px',
    height: '40px',
    fontSize: '14px',
    fontWeight: 700,
};
export var Component = function (p) {
    var t = useTranslations().t;
    var theme = useTheme();
    return (Preact.h(Preact.Fragment, null, p.selected ? (Preact.h(MuiButton, { startIcon: Preact.h(CheckCircleIcon, null), variant: "contained", color: "success", sx: __assign({}, selectionButtonSx), onClick: p.onClick }, t('product.card.applied'))) : (Preact.h(LoadingButton, { variant: "text", color: "secondary", sx: __assign(__assign({}, selectionButtonSx), { '&:hover': {
                color: theme.palette.primary.main,
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                borderColor: theme.palette.primary.main,
            }, '& .MuiLoadingButton-loadingIndicatorStart': {
                left: '20%',
            } }), onClick: p.onClick, disabled: p.disabled, loading: p.loading, loadingIndicator: Preact.h(CircularProgress, { color: "inherit", size: 16 }), loadingPosition: "start" },
        Preact.h("span", null, p.loading ? t('product.card.applying') : t('product.card.apply'))))));
};
